import Api, { Accommodation, AccommodationRequest } from '@silbo/core';

export const getAccommodationFromRequestQuery = (request: AccommodationRequest) =>
  new Api.Query(Accommodation).equalTo('basedOn', request).select('startAt');
